import { enabledByParams, RequestOptions, RequestParams, RequestQueryOptions } from '@approvalmax/data';
import { useGet } from 'shared/data/api';

import { contactsApiPaths } from '../paths';
import { GetContactRole } from './useGetContactRole.types';

export const useGetContactRole = (
    params?: RequestParams<GetContactRole>,
    queryOptions?: RequestQueryOptions<GetContactRole>,
    options?: RequestOptions
) =>
    useGet(contactsApiPaths.contactRole, {
        params,
        queryOptions: {
            ...queryOptions,
            enabled: enabledByParams<GetContactRole['params']['path']>(
                {
                    organizationId: params?.path?.organizationId,
                    contactId: params?.path?.contactId,
                },
                queryOptions
            ),
        },
        apiSource: 'wallets',
        apiVersion: 'v1',
        ...options,
    });
